export default "__VITE_ASSET__DZhy9swy__"